/**
 * AfgSubmissionModal — Record AFG submission for PI insurance policies
 *
 * NOTE: The current schema (schema-compliance.ts) does NOT have
 * afgSubmissionDate or afgReference columns on insurance_policies.
 * This modal is shown as "coming soon" until the schema is extended.
 *
 * When schema support is added, this modal will PATCH the policy
 * with afgSubmissionDate and afgReference.
 */

import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Info } from "lucide-react";

// ---------------------------------------------------------------------------
// Types
// ---------------------------------------------------------------------------

interface AfgSubmissionModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  policyId: string;
}

// ---------------------------------------------------------------------------
// Component
// ---------------------------------------------------------------------------

export function AfgSubmissionModal({
  open,
  onOpenChange,
}: AfgSubmissionModalProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        className="max-w-md"
        data-testid="modal-afg-submission"
      >
        <DialogHeader>
          <DialogTitle>Record AFG Submission</DialogTitle>
          <DialogDescription>
            Record an AFG submission date and reference for this PI policy.
          </DialogDescription>
        </DialogHeader>

        <div
          className="flex items-start gap-3 rounded-lg border border-blue-200 bg-blue-50 p-4"
          data-testid="afg-coming-soon-notice"
        >
          <Info className="mt-0.5 h-4 w-4 shrink-0 text-blue-600" />
          <div className="text-sm text-blue-800">
            <p className="font-medium">Coming soon</p>
            <p className="mt-1">
              AFG submission tracking requires additional schema fields.
              This feature will be available in a future release.
            </p>
          </div>
        </div>

        <DialogFooter>
          <Button onClick={() => onOpenChange(false)}>
            Close
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
